import { Brand } from '@/entities/brand/model/types';
import { create } from 'zustand';

interface BrandState {
  brand: Brand | null;
  setBrand: (brand: Brand) => void;
  clearBrand: () => void;
}

export const useBrandStore = create<BrandState>()((set) => ({
  brand: null,

  setBrand: (brand) => set({ brand }),
  clearBrand: () => set({ brand: null }),
}));
